import moment from 'moment';

Vue.component('attendance-show', {
  data: function () {
    return {
      attendanceLoading: false,
      workDaysLoading: true,
      massButtonLoading: false,
      initSetDataComplete: false,
      days: [],
      mutableAttendance: {},
      modalLoadingDate: null,
      mutableWorkedHolidays: {},
      mutableBalances: {},
      mutableUrl: '',
      selectedMonthMutable: {},
      loading: false,
      pageLoading: false,
      year: null,
      month: null,
      mutableLegalChecks: [],
      legalChecksDataFinal: true,
      legalChecksRefreshIntervalLengthStandard: 30, // const - standard interval length (sec)
      legalChecksRefreshIntervalLengthFaster: 15, // const - faster interval length (sec)
      legalChecksRefreshInterval: null, // reference to setInterval instance
      legalChecksRefreshIntervalLimit: 10, // current (working) limit (sec) . contains one of values (Standard or Faster interval length) ... initial value
      legalChecksRefreshIntervalState: 0, // current (working) state (ticks)
    }
  },

  props: {
    'transMonths': {
      type: Object
    },
    'selectedMonth': {
      type: Object,
      default() {
        return null;
      }
    },
    'attendance': {
      type: Object,
      default() {
        return null;
      }
    },
    'balances': {
      type: Object,
    },
    'workedHolidays': {
      type: Array
    },
    'baseUrl': {
      type: String
    },
    'attendanceUrl': {
      type: String
    },
    'workDaysApiUrl': {
      type: String
    },
    'lockMonthUrl': {
      type: String
    },
    'unlockMonthUrl': {
      type: String
    },
    'workedHolidaysUrl': {
      type: String
    },
    'legalChecksDataUrl': {
      type: String
    },
    'balancesUrl': {
      type: String
    },
    'legalChecksEnabled': {
      type: Boolean
    }
  },

  created() {
    this.fetchDays();

    this.year = Number(moment(this.selectedMonth.key).format('YYYY'));
    this.month = Number(moment(this.selectedMonth.key).format('MM'));

    this.selectedMonthMutable = this.selectedMonth.key;
    this.mutableUrl = this.baseUrl;

    this.mutableAttendance = this.attendance;
    this.mutableWorkedHolidays = this.workedHolidays;
    this.mutableBalances = this.balances;

    this.$nextTick(function () {
      this.initSetDataComplete = true;
    });

    this.refreshLegalChecks(true);
    this.legalChecksRefreshInterval = setInterval(this.refreshLegalChecks, 1000);
  },

  mounted() {
    let that = this;
    // hack: because onpopstate really does not work! (SO guys lies)
    // this will cause switch back pageLoading variable after X sec, but the time have to be longer than time needed to load data of next loaded page, otherwise it will not look good
    // after moving via "back button" timeout will continue in time in which it was stopped after moving to next page
    window.onbeforeunload = function () {
      setTimeout(() => {
        that.pageLoading = false;
      }, 6000);
    };
  },

  methods: {
    chooseMonth(year, month, selectedObj) {
      this.selectedMonthMutable = year + "-" + (month < 10 ? "0" : "") + month;

      this.year = year;
      this.month = month;

      const momentDate = moment(this.selectedMonthMutable, "YYYY-MM");

      this.dateUrlPath = momentDate.format("YYYY/MM");
      this.mutableUrl = (selectedObj ? selectedObj.url : this.baseUrl + "/" + this.dateUrlPath);

      this.refreshData();
    },

    refreshData() {
      if (this.initSetDataComplete && !this.attendanceLoading) {
        this.pageLoading = true;
        window.location = this.mutableUrl;
      }
    },

    refreshAttendance(withLoading = true) {
      if (withLoading) {
        this.attendanceLoading = true;
      }

      this.fetchAttendance();
      this.refreshLegalChecksEmit();
    },

    refreshCalendar(withLoading = true) {
      if (withLoading) {
        this.workDaysLoading = true;
      }

      this.fetchDays();
    },

    refreshBalances() {
      let _this = this;
      axios.get(this.balancesUrl).then(function (response) {
        _this.mutableBalances = response.data;
        _this.attendanceLoading = false;
      }, function (error) {
        _this.attendanceLoading = false;
      });
    },

    refreshWorkedHolidays() {
      let _this = this;
      axios.get(this.workedHolidaysUrl).then(function (response) {
        _this.mutableWorkedHolidays = response.data;
        _this.attendanceLoading = false;
      }, function (error) {
        _this.attendanceLoading = false;
      });
    },

    refreshLegalChecks(instant) {
      if (!this.legalChecksEnabled) { // FF check
        return;
      }

      if (!instant && this.legalChecksRefreshIntervalState < this.legalChecksRefreshIntervalLimit) {
        this.legalChecksRefreshIntervalState++;
        return;
      }

      this.legalChecksRefreshIntervalState = 0;

      axios.get(this.legalChecksDataUrl).then((response) => {
        this.mutableLegalChecks = response.data.items || [];
        this.legalChecksDataFinal = response.data.isFinal;
        this.legalChecksRefreshIntervalLimit = (instant || !response.data.isFinal ? this.legalChecksDataFinal : this.legalChecksRefreshIntervalLengthStandard);
      }, (error) => {
        this.legalChecksDataFinal = false;
        this.legalChecksRefreshIntervalLimit = this.legalChecksRefreshIntervalLengthFaster;
      });
    },

    refreshLegalChecksEmit() {
      this.mutableLegalChecks = [];
      this.legalChecksRefreshIntervalLimit = this.legalChecksRefreshIntervalLengthFaster;
      this.legalChecksDataFinal = false;
      this.refreshLegalChecks(true);
    },

    setModalLoadingDate(date) {
      this.modalLoadingDate = date ? date.format('YYYY-MM-DD') : null;
    },

    setMassButtonLoading(show) {
      if (show) {
        this.workDaysLoading = true;
      }

      this.massButtonLoading = show;
    },

fetchDays() {
      let _this = this;

      axios.get(this.workDaysApiUrl).then(function (response) {
        _this.days = response.data;
        _this.workDaysLoading = false;
      }, function (error) {
        _this.workDaysLoading = false;
      });
    },

    fetchAttendance() {
      let _this = this;
      axios.get(this.attendanceUrl).then(function (response) {
        _this.mutableAttendance = response.data;
        _this.attendanceLoading = false;
      }, function (error) {
        _this.attendanceLoading = false;
      });
    },

    fetchWorkedHolidaysForModal() {
      let _this = this;
      axios.get(this.attendanceUrl).then(function (response) {
        _this.mutableAttendance = response.data;
        _this.attendanceLoading = false;
      }, function (error) {
        _this.attendanceLoading = false;
      });
    },

    toggleLockedMonth(lock) {
      let _this = this;
      let url = null;

      if (lock) {
        url = this.lockMonthUrl;
      } else {
        url = this.unlockMonthUrl;
      }

      this.workDaysLoading = true;

      axios.post(url).then(function (response) {
        _this.refreshCalendar();
        _this.refreshAttendance(false);

        _this.$notify({
          type: 'success',
          title: 'Success!',
          text: response.data.message ? response.data.message : 'Item successfully updated.'
        });
        // _this.workDaysLoading = false;
      }, function (error) {
        _this.refreshCalendar();
        _this.refreshAttendance(false);

        _this.$notify({
          type: 'error',
          title: 'Error!',
          text: error.response.data.message ? error.response.data.message : 'An error has occured.'
        });
        _this.workDaysLoading = false;
      });
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/attendance/Show.js